import { render, staticRenderFns } from "./my-club.vue?vue&type=template&id=0905a14c&scoped=true"
import script from "./my-club.vue?vue&type=script&lang=js"
export * from "./my-club.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0905a14c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/subsapp-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0905a14c')) {
      api.createRecord('0905a14c', component.options)
    } else {
      api.reload('0905a14c', component.options)
    }
    module.hot.accept("./my-club.vue?vue&type=template&id=0905a14c&scoped=true", function () {
      api.rerender('0905a14c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/club-manage/my-club.vue"
export default component.exports